<template>
  <div
    class="loader"
    :style="styles"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import get from 'lodash/get';

defineOptions({ name: 'LoadingIndicator' });

const props = defineProps({
  size: {
    type: Number,
    default: 45,
  },
});

const store = useStore();
const styles = computed(() => {
  const globals = store.state.globals;
  const primaryColor = get(globals, 'info.primary_color.hex', '#000000');
  const borderWidth = (props.size * 0.1).toString();
  return {
    '--spinner-width': `${props.size}px`,
    '--spinner-height': `${props.size}px`,
    '--spinner-border': `${borderWidth}px solid ${primaryColor}80`,
    '--spinner-borderTop': `${borderWidth}px solid ${primaryColor}`,
  };
});
</script>

<style lang="scss" scoped>
.loader {
  margin: 20px auto;
  border-radius: 50%;
  -webkit-animation: spin 0.5s linear infinite;
  animation: spin 0.5s linear infinite;
  width: var(--spinner-width);
  height: var(--spinner-height);
  border: var(--spinner-border);
  border-top: var(--spinner-borderTop);
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
